const houseTypesSchema = [];

export default houseTypesSchema;
